import { render, staticRenderFns } from "./OBtnCircleToolTipComp.vue?vue&type=template&id=63357234&"
import script from "./OBtnCircleToolTipComp.vue?vue&type=script&lang=js&"
export * from "./OBtnCircleToolTipComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports